import Spreadsheets from 'dash/js/services/Spreadsheets'

export const setAction = ({ commit }, action) => commit('SET_ACTION', action);

export const clearInformation = ({ commit }) => commit('CLEAR_INFORMATION');

export const retrieveTemplates = ({ commit }) => {
  Spreadsheets.retrieveTemplates(response => {
    commit('RETRIEVE_TEMPLATES', response.data);
  });
};

export const verifyZipCode = async (_, payload) => {
  return await Spreadsheets.verifyZipCode(payload.zipCode)
}

export const openModal = ({ commit }) => {
  commit('ENABLE_MODAL')
}

export const closeModal = ({ commit }) => {
  commit('DISABLE_MODAL');
}

export const retrieveShippingServices = async ({ commit }, templateId) => {
  if (templateId) {
    await Spreadsheets.retrieveShippingServices(response => {
      commit('RETRIEVE_SHIPPING_SERVICES', response.data);
    }, templateId);
  }
}

export const retrieveSpreadsheets = ({ commit }, param) => {
  commit('ENABLE_LOADING');

  Spreadsheets.retrieveSpreadsheets(param, response => {
    commit('RETRIEVE_SPREADSHEETS', response.data);
    commit('DISABLE_LOADING');
  });
}

export const setInformation = ({ commit }, data) => {
  commit('SET_INFORMATION', data);
}

export const createSpreadsheet = async ({ commit, state }) => {
  commit('ENABLE_LOADING')
  Spreadsheets.createSpreadsheet(state.table_data)
    .then(() => {
      commit('DISABLE_LOADING');
      commit('CLEAR_INFORMATION');
    })
    .catch(error => console.warn(error));
}

export const editSpreadsheet = async ({ commit, state }) => {
  commit('ENABLE_LOADING')
  Spreadsheets.updateSpreadsheet(state.table_data, state.table_data.id)
    .then(() => {
      commit('CLEAR_INFORMATION');
      commit('DISABLE_LOADING');
    })
    .catch(error => console.warn(error));
}

export const deleteSpreadsheet = async ({ commit }, spreadsheetId) => {
  commit('ENABLE_LOADING')
  await Spreadsheets.deleteSpreadsheet(spreadsheetId)
    .then(() => {
      commit('DISABLE_LOADING')
      commit('DISABLE_MODAL');
    })
    .catch(error => console.warn(error));
}
